import React, { useEffect, useState } from 'react'

import {
  Avatar,
  Box,
  Button,
  Grid,
  LinearProgress,
  Stack,
  Typography,
} from '@mui/material'
import API from '../../../../services/API'
import BigModal from '../../../../components/Modals/BigModal'
import EditAccess from './EditAccess'

const CADAccess = () => {
  const [loading, setLoading] = useState(true)
  const [employees, setEmployees] = useState([])
  const [openEdit, setOpenEdit] = useState(false)

  const loadList = () => {
    API.get('/company-settings-cad-permissions')
      .then((res) => {
        if (res.status === 200) {
          setEmployees(res.data)
        }
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => loadList(), [])

  const viewers = {
    title: 'Viewers',
    employees: employees.filter((x) => x?.cadAccess === 'Viewer'),
    color: 'anGreen.main',
  }
  const callTakers = {
    title: 'Call Takers',
    employees: employees.filter((x) => x?.cadAccess === 'Call Taker'),
    color: 'anOrange.main',
  }
  const dispatchers = {
    title: 'Dispatchers',
    employees: employees.filter((x) => x?.cadAccess === 'Dispatcher'),
    color: 'anBlue.main',
  }
  const commander = {
    title: 'Commanders',
    employees: employees.filter((x) => x?.cadAccess === 'Commander'),
    color: 'anPurple.main',
  }

  return (
    <Stack gap={1}>
      <Typography variant="title2">CAD Access</Typography>
      {loading && <LinearProgress />}
      <Button
        variant="contained"
        size="small"
        fullWidth
        onClick={() => setOpenEdit(true)}
      >
        Update Permissions
      </Button>
      <Grid container spacing={2}>
        {[viewers, callTakers, dispatchers, commander].map((x) => (
          <Grid item xs={12} md={6} lg={3} key={x.title}>
            <Box border="solid 2px" borderRadius="2px" borderColor={x.color}>
              <Stack>
                <Box
                  paddingX={2}
                  paddingY={1}
                  bgcolor={x.color}
                  display="flex"
                  justifyContent="center"
                >
                  <Typography variant="title3" color="white">
                    {x.title}
                  </Typography>
                </Box>
                <Box
                  paddingX={2}
                  paddingY={1}
                  display="flex"
                  flexDirection="column"
                >
                  {(x?.employees ?? []).map((emp) => (
                    <Box display="flex" gap={1} key={emp._id}>
                      <Avatar
                        src={emp.userAccount.photograph}
                        sx={{ height: 24, width: 24 }}
                      />
                      <Typography>
                        {emp.userAccount.firstName} {emp.userAccount.lastName}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Stack>
            </Box>
          </Grid>
        ))}
      </Grid>
      <BigModal open={openEdit} onClose={() => setOpenEdit(false)}>
        <EditAccess onClose={() => setOpenEdit(false)} loadList={loadList} />
      </BigModal>
    </Stack>
  )
}

export default CADAccess
